import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { PageContainer } from '@/components/shared/PageContainer';
import { useTranslator } from '@/hooks/useTranslator';
import { BulkInviteSheet } from '../-components/BulkInviteSheet';
import { CsToolCard } from '../-components/CsToolCard';

export const Route = createFileRoute('/management/cs-tools/(pages)/')({
  component: CsToolsPage,
});

/**
 * Customer Success tooling — admin utilities that belong to no single
 * management entity. One card per tool, each opening its own guided flow.
 */
function CsToolsPage() {
  const { getTranslation: t } = useTranslator({ page: 'csTools' });
  const [isBulkInviteOpen, setBulkInviteOpen] = useState(false);

  return (
    <PageContainer className='overflow-y-auto gap-4'>
      <div className='flex flex-col gap-0.5'>
        <p className='text-sm font-semibold text-foreground leading-tight'>
          {t('title')}
        </p>
        <p className='text-xs text-muted-foreground'>{t('subtitle')}</p>
      </div>

      <CsToolCard
        icon={faUsers}
        title={t('bulkInvite.cardTitle')}
        description={t('bulkInvite.cardDescription')}
        actionLabel={t('bulkInvite.open')}
        onAction={() => setBulkInviteOpen(true)}
        data-cy='open-bulk-invite'
      />

      <BulkInviteSheet
        open={isBulkInviteOpen}
        onOpenChange={setBulkInviteOpen}
      />
    </PageContainer>
  );
}
